import { PureComponent } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';

import TopicsSvc from '../../../services/TopicsSvc';

import Breadcrumbs from '../../Breadcrumbs';
import SeoCard from '../SeoCard';
import Preloader from '../../Preloader';

import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';
import withComponentName from '../../../decorators/withComponentName';

import { TOPIC_CLASS_BREADCRUMBS, DIRECTORIES_PATH, topicClassesDescriptions } from '../../../data/directory/constants';

import Styles from './styles.module.scss';

class TopicClasses extends PureComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      topicClasses: [],
      expanded: false,
      width: 0,
    };
  }

  async componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange, { passive: true });
    this.handleWindowSizeChange();
    const topicClasses = await TopicsSvc.getTopicClasses();

    this.setState({
      topicClasses: topicClasses.map((topic) => ({
        ...topic,
        path: `${DIRECTORIES_PATH}/${topic.slug}`,
      })),
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange() {
    this.setState({ width: window.innerWidth });
  }

  toggleExpand() {
    this.setState(({ expanded }) => ({
      expanded: !expanded,
    }));
  }

  render() {
    const { searchBarActive } = this.props;
    const { topicClasses, expanded, width } = this.state;
    const isMobile = width <= 767;

    return (
      <article
        className={
          `${Styles['topic-classes']}
           ${searchBarActive && Styles['blured-background']}`
        }
      >
        <article>
          <Breadcrumbs items={TOPIC_CLASS_BREADCRUMBS} />
          <section>
            <h2 className={Styles.subtitle}>
              Top financial, economic, and business news and research for
            </h2>
            <h1 className={Styles.title}>Topics &amp; Asset Classes</h1>
            {!isMobile && (
              <h3>
                We&apos;ve made it easy to drill down into the financial&nbsp;
                and market news universe.&nbsp;
                Simply choose a topic or asset class to begin your exploratory&nbsp;
                journey and start reaping the benefits of CityFalcon&apos;s&nbsp;
                proprietary machine learning algorithms to guide your way.
              </h3>
            )}
            {isMobile && (
              <>
                <div onClick={this.toggleExpand} className={`${expanded ? Styles.expandedDescription : Styles.closedDescription} ${Styles.descriptionWrapper}`}>
                  <h3>{topicClassesDescriptions['Topics & Asset Classes']}</h3>
                </div>
                <span className={Styles.description} onClick={this.toggleExpand}>
                  Show&nbsp;
                  {expanded ? 'Less' : 'More'}
                  <FontAwesomeIcon
                    className="img mob"
                    icon={expanded ? faAngleUp : faAngleDown}
                  />
                </span>
              </>
            )}
            <div className={`${!topicClasses.length ? Styles['pos-static'] : Styles['topics-list']}`}>
              {topicClasses.length ? (
                topicClasses.map((topic) => (
                  <SeoCard
                    key={topic.id}
                    card={topic}
                  />
                ))
              ) : (
                <Preloader loading />
              )}
            </div>
          </section>
        </article>
      </article>
    );
  }
}

const mapStateToProps = (state) => ({
  searchBarActive: state.searchReducers.searchBarActive,
});

export default withComponentName(
  connect(mapStateToProps)(withMetatag(TopicClasses, 'news/directory/topic-class')),
);
